<div class="p-5" style="width: 600px; max-width: 95vw;">
  <div class="flex justify-between items-center mb-2">
    <div class="text-lg text-gray-700 font-bold">
      {{ data.item.veiculo?.agendaId ? 'Trocar veículo' : 'Alocar veículo' }}
    </div>
    <button class="btn-icon" (click)="close()"><mat-icon>close</mat-icon></button>
  </div>
  <div class="text-sm text-gray-500 mb-4">TG {{ data.item.codigoTg }} · OS {{ data.item.codigoOs }}</div>

  <mat-form-field class="input-tg w-full px-2" appearance="outline" hideRequiredMarker>
    <mat-label>Buscar por placa ou modelo</mat-label>
    <input matInput [(ngModel)]="busca" />
  </mat-form-field>

  @if (loading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  <div class="flex flex-col gap-1 mt-2" style="max-height: 360px; overflow-y: auto;">
    @for (veiculo of veiculosFiltrados; track veiculo.id) {
      <div class="flex justify-between items-center border-b py-2 px-2">
        <div>
          <div class="font-medium">{{ veiculo.placa }}</div>
          <div class="text-xs text-gray-500">{{ veiculo.modelo }} · {{ veiculo.descricaoTipoVeiculo }}</div>
        </div>
        <button
          mat-flat-button
          class="btn-tg"
          [disabled]="salvandoId !== null"
          (click)="selecionar(veiculo)"
        >
          @if (salvandoId === veiculo.id) {
            <mat-spinner diameter="20" class="loading-spinner"></mat-spinner>
          } @else {
            Selecionar
          }
        </button>
      </div>
    } @empty {
      @if (!loading) {
        <div class="text-center text-gray-400 py-4">Nenhum veículo livre encontrado.</div>
      }
    }
  </div>
</div>
